import { render } from "./Btn.vue?vue&type=template&id=4ef205d0&lang=pug"
import script from "./Btn.vue?vue&type=script&lang=js"
export * from "./Btn.vue?vue&type=script&lang=js"

import "./Btn.vue?vue&type=style&index=0&id=4ef205d0&lang=css"

import exportComponent from "/var/jenkins_home/jobs/ohm-landing/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__